<template>
	<div class="login_box">
		<div class="p_flex p_box ">
			<div class="one_left">
				<div class="one_left-tiw"><img src="../../assets/img/Boss_Two Color.png"/></div>
			</div>
			<div class="one_two  ">
				<div><span class="p_flex p_m_a_a p_m_a_b subject_color type_size_30 ">欢迎使用慧作业</span></div>
				<div class="two_box">
					<div class="p_flex p_login p_f_a">
						<span class="p_m_l_30 type_size_18 ">账户</span>
						<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30">
							<el-input type="text" v-model="account" placeholder="请输入账户"></el-input>
						</div>
					</div>
					<div class="p_flex p_login p_f_a p_m_a_a">
						<span class="p_m_l_30 type_size_18 ">密码</span>
						<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30">
							<el-input type="password" v-model="password" placeholder="请输入密码"></el-input>
						</div>
					</div>
				</div>
				<div class="p_flex subject_yellow p_f_e p_m_r_60 p_m_t_20 type_size_16 small_hand">
					<span @click="goSecurity">密保找回</span>
					<span class="p_m_l_60" @click="goMobile">手机号找回</span>
				</div>
				<div class="p_m_a_a">
					<div class="two_com ">
						<el-button type="success" @click="goLogin()">确认</el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="footer">
			<a href="javascript:" onClick="window.open('http://beian.miit.gov.cn/')">滇ICP备2021007786号</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Login',
	data() {
		return {
			account: '',
			password: '',
			id: '' //是老师还是学生   0老师   1学生
			// name:""
		};
	},
	created() {
		// console.log(this.$route.query.id)
		this.id = this.$route.query.id;
	},
	methods: {
		post() {
			this.$request
				.ajax(this)
				.post('/api/account_login', {
					user_type: this.id == 0 ? 'teacher' : 'student',
					account: this.account,
					password: this.password
				})
				.then(res => {
					// console.log(res)
					sessionStorage.setItem('token', res.data.token);
					this.$store.commit('login', parseInt(this.id));
					if (!res.data.login.phone) {
						this.$router.push({
							path: 'Mobile',
							query: {
								id: 'empty'
							}
						}); //绑定手机号
						return;
					}
					if (this.id == 0) {
						this.$router.push('/Homet'); //老师端
						this.$store.commit('login', res.data.login);
					}
					if (this.id == 1) {
						this.$router.push('/Homes'); //学生端
						this.$store.commit('login', res.data.login);
					}
				});
		},
		goLogin() {
			this.post();
		},
		goSecurity() {
			if (!this.account) {
				this.$message.error('请先输入账号！');
				return;
			}
			this.$request
				.ajax(this)
				.post('/api/security_question', {
					account: this.account,
					user_type: this.id == 0 ? 'teacher' : 'student'
				})
				.then(res => {
					//   console.log(res)
					if (res.data.length == 0) {
						this.$message.error('该账号未设置密保问题!');
						return;
					} else {
						this.$router.push({
							path: 'Security',
							query: {
								id: this.account
							}
						});
					}
				});
		},
		goMobile() {
			this.$router.push({
				path: 'Mobile',
				query: {
					id: 'Retrieve'
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.one_left {
	width: 50%;
	background-color: #fafafa;
	border-radius: 20px 0px 0px 20px;
}

.one_left .one_left-tiw {
	width: 80%;
	margin: 15% auto 0;
}

.p_m_a_a {
	margin-top: 10%;
}

.p_m_a_b {
	margin-left: 15%;
}

.two_box {
	width: 70%;
	margin: 10% auto 0;
}

.p_login {
	width: 100%;
}

.one_two {
	width: 50%;
	background: #ffffff;
	border-radius: 0px 20px 20px 0px;
}

.p_m_t_a {
	margin-top: 20%;
}

.p_m_t_b {
	margin-top: 15%;
}

.two_com {
	width: 50%;
	margin: 0 auto;
}

.two_log {
	width: 40%;
	margin: 10% auto 0;
	// background: #0000FE;
	// margin: 100px auto 0;
}

.el-button--success {
	width: 100%;
	margin: 0 auto;
}

.el-button {
	border-radius: 20px;
	font-size: 22px;
	padding: 20px;
}

.footer {
	display: flex;
	justify-content: center;
	font-size: 16px;
	margin-top: 50px;
}

.login_box {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 60%;
	height: 85%;
}

img {
	width: 100%;
	height: auto;
	object-fit: cover;
}

.p_box {
	width: 100%;
	height: 80%;
}

> > > .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}

> > > input::-webkit-input-placeholder {
	font-size: 18px;
}


.footer {
	display: flex;
	justify-content: center;
	font-size: 16px;
	margin-top: 50px;
}


</style>



// WEBPACK FOOTER //
// src/components/login/login.vue